module.exports = __webpack_public_path__ + "img/thumbnail_PronghornAntelope_j_albino.86801ec2.png";